<template>
  <div>
    <AllPropertiesTable />
  </div>
</template>

<script>
export default {
  components: {
    AllPropertiesTable: () =>
      import("@/all-properties/components/AllPropertiesTable.vue"),
  },
  data() {
    return {};
  },

  mounted() {},

  methods: {},
};
</script>

<style scoped>
</style>